<template>

  <body class="dx-viewport">
    <DxDataGrid ref="dataGrid" :allowColumnReordering="true" :data-source="dsTipuriActivitati"
      :allowColumnResizing="true" :columnAutoWidth="false" :columnMinWidth="50" :columnResizingMode="'nextColumn'"
      :show-borders="true" :syncLookupFilterValues="false" :filter-sync-enabled="true" :show-row-lines="true"
      :show-column-lines="false" @selection-changed="onSelectionChanged" @row-inserting="onRowInserting"
      @row-updating="onRowUpdating" @row-removing="onRowRemoving" class="border">
      <DxSelection mode="single" />
      <DxFilterRow :visible="true" />
      <DxPaging :page-size="10" :page-index="0" />
      <DxLoadPanel :enabled="true" :indicator-src="'reload6.gif'" />
      <DxSorting mode="multiple" />
      <DxStateStoring :enabled="true" :filterValue="false" storage-key="TipuriActivitati" />
      <DxToolbar>
        <DxItem>
          <template #default>
            <DxButton icon="add" type="success" @click="onAddClick" />
          </template>
        </DxItem>
        <DxItem>
          <template #default>
            <DxButton icon="refresh" @click="onRefreshClick" />
          </template>
        </DxItem>
      </DxToolbar>

      <!-- Editare  -->
      <DxEditing :allowUpdating="true" :allowDeleting="true" mode="popup">
        <DxPopup :showCloseButton="false" :width="600" :height="450">
          <DxToolbarItem :template="customTitle" />
          <DxToolbarItem toolbar="bottom" widget="dxButton" location="after" :options="successButtonOptions" />
          <DxToolbarItem toolbar="bottom" widget="dxButton" location="after" :options="dangerButtonOptions" />
        </DxPopup>
        <DxFormGrid :colCount="2" columnWidth="300">
          <DxItem dataField="Nume" :colSpan="1" cssClass="form-item">
            <DxValidationRule>
              <DxRequiredRule />
            </DxValidationRule>
          </DxItem>
          <DxItem dataField="ValutaId" :editorType="'dxSelectBox'"
            :editorOptions="{ dataSource: valute, displayExpr: 'Simbol', valueExpr: 'Id', width: 260 }"
            cssClass="form-item" :label="{ text: 'Valută' }">
            <DxValidationRule>
              <DxRequiredRule />
            </DxValidationRule>
          </DxItem>
          <DxItem dataField="DurataEstimata" :colSpan="1" cssClass="form-item"
            :label="{ text: 'Durată estimativă în zile' }">
            <DxValidationRule>
              <DxRequiredRule />
            </DxValidationRule>
          </DxItem>
          <DxItem dataField="CostImplicit" :colSpan="1" cssClass="form-item" width: 250>
            <DxValidationRule>
              <DxRequiredRule />
            </DxValidationRule>
          </DxItem>


          <DxItem dataField="Explicatie" caption="Explicație" :colSpan="2" :editor-options="{ width: 560, height: 100 }"
            cssClass="form-item-full" />




        </DxFormGrid>
      </DxEditing>

      <!-- Coloane Grid -->
      <DxColumn data-field="Nume" />
      <DxColumn data-field="Explicatie" caption="Explicație" />
      <DxColumn data-field="CostImplicit" />
      <DxColumn data-field="DurataEstimata" caption="Durată Estimată" />
      <DxColumn data-field="ValutaNume" caption="Nume Valută" />
      <DxColumn data-field="ValutaId" caption="Valuta" :visible="false" />
    </DxDataGrid>


    <!-- Adaugare -->
    <DxPopupAdd :visible.sync="isModalVisible" :showCloseButton="false" :showTitle="true" :width="600" :height="430">
      <template #title>
        <div
          style="background-color: #ff2c21; font-size: 15px; color: white; font-weight: bold; padding: 10px; padding-left: 20px;">
          Adăugare
        </div>
      </template>
      <DxToolbarItem toolbar="bottom" widget="dxButton" location="after" :options="addSaveButtonOptions" />
      <DxToolbarItem toolbar="bottom" widget="dxButton" location="after" :options="addCancelButtonOptions" />
      <div>
        <DxForm :formData="formData">
          <DxItem :col-span="2" :col-count="2" item-type="group">
            <DxItem dataField="Nume" :isRequired="true" :editor-options="{ width: 260 }">
              <DxValidationRule>
                <DxRequiredRule />
              </DxValidationRule>
            </DxItem>
            <DxItem dataField="ValutaId" caption="Valuta" :isRequired="true" :editorType="'dxSelectBox'"
              :editorOptions="{ dataSource: valute, displayExpr: 'Simbol', valueExpr: 'Id', width: 260 }"
              :label="{ text: 'Valută' }">
              <DxValidationRule>
                <DxRequiredRule />
              </DxValidationRule>
            </DxItem>
            <DxItem dataField="DurataEstimata" :isRequired="true" :editor-options="{ width: 260 }"
              :label="{ text: 'Durată estimativă în zile' }">
              <DxValidationRule>
                <DxRequiredRule />
              </DxValidationRule>
            </DxItem>
            <DxItem dataField="CostImplicit" :isRequired="true" :editor-options="{ width: 260 }">
              <DxValidationRule>
                <DxRequiredRule />
              </DxValidationRule>
            </DxItem>
          </DxItem>
          <DxItem dataField="Explicatie" caption="Explicație" :editor-options="{ width: 560, height: 100 }" />
        </DxForm>
      </div>
    </DxPopupAdd>





  </body>
</template>


<script lang="ts">
import { defineComponent, ref } from 'vue';
import { DxButton } from 'devextreme-vue/button';
import DxPopupAdd, { DxToolbarItem } from 'devextreme-vue/popup';
import { DxItem, DxForm, DxLabel } from 'devextreme-vue/form';
import {
  DxColumn,
  DxDataGrid,
  DxFilterRow,
  DxLoadPanel,
  DxPaging,
  DxSelection,
  DxSorting,
  DxStateStoring,
  DxToolbar,
  DxEditing,
  DxPopup,
  DxItem as DxItemForm,
  DxForm as DxFormGrid,
  DxValidationRule,
  DxRequiredRule,
} from 'devextreme-vue/data-grid';
import 'devextreme/dist/css/dx.light.css';
import 'devextreme/dist/css/dx.common.css';
import ODataStore from 'devextreme/data/odata/store';
import AppSetting from '@/settings/appSettings';
import CRM_Services from '@/services/Comercial/CrmService';
import ResponseData from '@/types/responseData';
import notify from 'devextreme/ui/notify';
import { locale, loadMessages } from 'devextreme/localization';
import CrmTipuriActivitati from '@/services/Comercial/CrmTipuriActivitati';
import http from "@/settings/apiSettings";

export default defineComponent({
  components: {
    DxToolbar,
    DxDataGrid,
    DxColumn,
    DxSorting,
    DxSelection,
    DxFilterRow,
    DxStateStoring,
    DxLoadPanel,
    DxPaging,
    DxButton,
    DxItem,
    DxPopup,
    DxForm,
    DxLabel,
    DxEditing,
    DxPopupAdd,
    DxToolbarItem,
    DxItemForm,
    DxFormGrid,
    DxValidationRule,
    DxRequiredRule,
  },
  data() {
    return {
      dsTipuriActivitati: {} as ODataStore,
      valute: [] as any[],
      isModalVisible: false,
      formData: {
        Nume: '',
        Explicatie: '',
        CostImplicit: '',
        DurataEstimata: '',
        ValutaId: '',
      },
      deleteConfirmationMessage: "Sigur doriți să ștergeți această înregistrare?",
      dataGrid: ref<DxDataGrid | null>(null),
      successButtonOptions: {
        type: 'success',
        stylingMode: 'contained',
        text: 'Salvează',
        onClick: () => {
          this.SaveEdit();
        },
      },
      dangerButtonOptions: {
        type: 'danger',
        stylingMode: 'contained',
        text: 'Închide',
        onClick: () => {
          this.onCancel();
        },
      },
      addSaveButtonOptions: {
        type: 'success',
        stylingMode: 'contained',
        text: 'Salvează',
        onClick: () => {
          this.onSave();
        },
      },
      addCancelButtonOptions: {
        type: 'danger',
        stylingMode: 'contained',
        text: 'Închide',
        onClick: () => {
          this.onCancel();
        },
      },
      customTitle() {
        return `
          <div style="background-color: #ff2c21; font-size: 15px; float: right; height:47px; width:665px; color: white; 
          font-weight: bold; padding: 12px; padding-right: 470px; position: relative; left: 30px;">
            Editare 
          </div>
        `;
      },
    };
  },
  methods: {
    async getValute() {
      try {
        const response = await http.clientComercialOdata.get('/ERP_Valute?$select=Id,Simbol');
        this.valute = response.data.value;
      } catch (e) {
        console.error("Error fetching valute:", e);
      }
    },
    createODataContext() {
      this.dsTipuriActivitati = new ODataStore({
        url: AppSetting.API_Url_ComercialOdata + 'CRM_CautareTipuriActivitati',
        key: 'ID',
        keyType: 'Guid',
        version: 4,
        beforeSend: (e) => {
          e.headers = {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt"),
          };
        },
      });
    },
    onSelectionChanged(e: any) {
      const selectedRow = e.selectedRowsData[0];
      this.$emit('selection-changed', selectedRow.ID);
    },
    onAddClick() {
      this.isModalVisible = true;
    },
    onSave() {
      if (!this.formData.Nume || this.formData.Nume.trim() === '') {
        notify('Completați câmpul obligatoriu "Nume"!', 'error', 1000);
        return;
      }
      if (!this.formData.CostImplicit || this.formData.CostImplicit.trim() === '') {
        notify('Completați câmpul obligatoriu "Cost Implicit"!', 'error', 1000);
        return;
      }
      if (!this.formData.DurataEstimata || this.formData.DurataEstimata.trim() === '') {
        notify('Completați câmpul obligatoriu "Durată Estimata"!', 'error', 1000);
        return;
      }
      if (!this.formData.ValutaId) {
        notify('Completați câmpul obligatoriu "Valută"!', 'error', 1000);
        return;
      }

      const savePromise = this.$refs.dataGrid?.instance?.saveEditData();
      const body = this.formData;
      CrmTipuriActivitati.save(body)
        .then((response) => {
          this.isModalVisible = false;
          notify('Datele au fost salvate cu succes!', 'success', 1000);
          this.formData = {
            Nume: '',
            Explicatie: '',
            CostImplicit: '',
            DurataEstimata: '',
            ValutaId: '',
          };
          this.$refs.dataGrid.instance.refresh();
        })
        .catch((error) => {
          console.error(error);
          notify('Numele există deja!', 'error', 1000);
        });
    },
    onCancel(e: any) {
      console.log("Cancel clicked");
      this.isModalVisible = false;
      const dataGrid = this.$refs.dataGrid.instance;
      if (dataGrid) {
        dataGrid.cancelEditData();
      } else {
        console.error("DataGrid instance not found");
      }
    },
    setDeleteConfirmationMessage() {
      const dataGrid = this.$refs.dataGrid.instance;
      dataGrid.option('editing', {
        allowUpdating: true,
        allowDeleting: true,
        mode: 'popup',
        texts: {
          confirmDeleteMessage: this.deleteConfirmationMessage,
          confirmDeleteTitle: "Confirmare Ștergere",
        },
      });
    },
    onClick() {
      this.isModalVisible = true;
    },
    onColumnChooserClick() {
      const dataGrid = this.$refs.dataGrid.instance;
      dataGrid.showColumnChooser();
    },
    onRefreshClick() {
      this.$refs.dataGrid.instance.refresh();
      notify('Datele au fost actualizate cu succes!', 'success', 1000);
    },
    SaveEdit() {
      const savePromise = this.$refs.dataGrid?.instance?.saveEditData();
      savePromise
        .then((result) => {
          this.dataGrid?.instance?.saveEditData();
        })
        .catch((error) => {
          console.error(error);
          notify('Numele există deja!', 'error', 1000);
        });
    },
    onRowRemoving(e: any) {
      e.cancel = new Promise((resolve) => {
        this.dataGrid?.instance?.saveEditData();
        notify('Datele au fost șterse cu succes!', 'success', 1000);
        resolve(false);
      });
    },
    onRowUpdating() {
      notify('Datele au fost editate cu succes', 'success', 1000);
    },
    onRowInserting() {
      notify('Datele au fost adăugate cu succes!', 'success', 1000);
    },
  },
  mounted() {
    this.getValute();
    this.createODataContext();
    this.setDeleteConfirmationMessage();
    loadMessages({
      "ro": {
        "Yes": "Da",
        "No": "Nu",
      },
    });
    locale('ro');
  },
});
</script>

<style scoped>
.border {
  border-radius: 8px;
}

.form-item {
  margin-bottom: 15px;
}

.form-item-full {
  margin-bottom: 15px;
}
</style>
